import React from 'react';
import './industry.css';

const Industry = () => {
    return (
<div class="industries-section">
  <h2>Industries We Serve</h2>
    <div class="grid-container">
        <div class="grid-item">Enterprise applications</div>
        <div class="grid-item">ERP</div>
        <div class="grid-item">Financial management</div>
        <div class="grid-item">Supply chain management</div>
        <div class="grid-item">Asset management</div>
        <div class="grid-item">Fleet management</div>
        <div class="grid-item">HR software</div>
        <div class="grid-item">eLearning software</div>
        <div class="grid-item">eCommerce</div>
        <div class="grid-item">Mobile apps</div>
        <div class="grid-item">Content management</div>
        <div class="grid-item">Document management</div>
        <div class="grid-item">CRM</div>
        <div class="grid-item">Marketing & advertising</div>
        <div class="grid-item">Web portals</div>
        <div class="grid-item">Data analytics</div>
    </div>
    </div>
    );
};

export default Industry;